import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../assets/Orange.png';
import '../css/french.css';
import '../css/navbar.css';
import { useLocation, useNavigate } from 'react-router-dom';

function Header() {

  const location = useLocation();
  const navigate = useNavigate();
  const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;

  const handleLogout = () => {
    let saveAndLogout = false;
    if (location.pathname === '/home') {
      saveAndLogout = window.confirm('Please ensure the form is saved before logging out.');
    }
    else {
      saveAndLogout = window.confirm('Are you sure you want to log out?')
    }
    if (saveAndLogout) {
      sessionStorage.setItem('email', '');
      sessionStorage.setItem('form', '');
      navigate('/');
    }
  };

  // const handleRequestAccess = () => {
  //   window.location.href = 'mailto:support.cdc@orange.com';
  // };
  // const handleRequestAccess = () => {
  //   const subject = encodeURIComponent("Short description of the error");
  //   const body = encodeURIComponent(
  //     `Hello support team,

  //     Please Find the below details:

  //     Issue description:
  //     User account:
  //     Browser used:
  //     Screenshot of the error message:

  //     Best Regards,
  //   `);

  //   window.location.href = `mailto:support.cdc@orange.com?subject=${subject}&body=${body}`;
  // };
  const handleRequestAccess = (isSupportRequest = false) => {
    let subject, body;

    if (isSupportRequest) {
      // Template for the "Support" button
      subject = encodeURIComponent("Short description of the error");
      body = encodeURIComponent(`
        Hello support team,

        Please Find the below details:

        Issue description:
        User account:
        Browser used:
        Screenshot of the error message:

        Best Regards,
      `);
    } else {
      // Template for the "Request Access" button
      subject = encodeURIComponent("Request Access for Letter of Authority Tool");
      body = encodeURIComponent(`
        Hello Team,

        Thanks for creating an account for Letter of Authority Tool with the below details,

        Account Creation details:
        Organization:
        First name:
        Last name:
        Email address:

        Best regards,
      `);
    }

    window.location.href = `mailto:btd.helpdesk@orange.com?subject=${subject}&body=${body}`;
  };

  const handleRequestAccessAdmin = () => {
    let subject, body;
    // Template for the "Support" button
    subject = encodeURIComponent("Short description of the error");
    body = encodeURIComponent(`
      Hello support team,

      Please Find the below details:

      Issue description:
      User account:
      Browser used:
      Screenshot of the error message:

      Best Regards,
    `);


    window.location.href = `mailto:support.cdc@orange.com?subject=${subject}&body=${body}`;
  };



  return (
    <Navbar expand="lg" className="bg-dark" data-bs-theme="dark">
      <Container>
        <Navbar.Brand className="d-flex align-items-center">
          <img src={logo} style={{ display: 'block' }} alt="Logo" />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto" activeKey="/home">

            {location.pathname === '/admin' && (
              <>
                <Nav.Link onClick={() => navigate('/loadashboard')}>Logs</Nav.Link>
                <Nav.Link onClick={() => navigate('/home')}>Go To Form</Nav.Link>
                <Nav.Link onClick={() => navigate('/admin/resetPassword')}>Reset Password</Nav.Link>
                {/* Support button */}
                <Nav.Link onClick={() => handleRequestAccessAdmin()}>Support</Nav.Link>

                {/* Logout button */}
                <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
              </>
            )}
            {(location.pathname === '/home' && sessionStorage.email === adminEmail) && (
              <>
                <Nav.Link onClick={() => navigate('/admin')}>Go To Admin Page</Nav.Link>
              </>
            )}

            {location.pathname === '/home' && (
              <>
                {/* Support button */}
                <Nav.Link onClick={() => handleRequestAccess(true)}>Support</Nav.Link>

                {/* Logout button */}
                <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
              </>
            )}

            {location.pathname === '/admin/resetPassword' && (
              <>
                <>
                  <Nav.Link onClick={() => navigate('/admin')}>Go To Admin Page</Nav.Link>
                </>
                {/* Support button */}
                <Nav.Link onClick={() => handleRequestAccess(true)}>Support</Nav.Link>

                {/* Logout button */}
                <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
              </>
            )}

            {location.pathname === '/loadashboard' && (
              <>
                <>
                  <Nav.Link onClick={() => navigate('/admin')}>Go To Admin Page</Nav.Link>
                </>
                {/* Support button */}
                <Nav.Link onClick={() => handleRequestAccess(true)}>Support</Nav.Link>

                {/* Logout button */}
                <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
              </>
            )}

            {/* {location.pathname === '/' && (
              // Request Access button
              <Nav.Link onClick={() => handleRequestAccess(false)}>Request Access/Support</Nav.Link>
            )} */}

            {location.pathname === '/' && (
              // Request Access button
              <Nav.Link
                className="request-access-link"
                onClick={() => handleRequestAccess(false)}
              >
                Request Access/Support
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

  );
}

export default Header;

